const TOKEN_STORAGE_KEYS = ['access_token', 'refresh_token', 'id_token', 'oq_id_token'];
const APP_BASENAME = '/v2';

const getBrowserLocation = () => {
    if (typeof window === 'undefined') {
        return { pathname: '/', search: '', hash: '' };
    }

    return window.location;
};

const getReturnPath = (location = getBrowserLocation()) => {
    const pathname = (location.pathname || '/').replace(new RegExp('^' + APP_BASENAME + '/?'), '/');
    const search = location.search || '';
    const hash = location.hash || '';

    return `${pathname}${search}${hash}`.replace(/^\/+/, '');
};

export const getLoginRedirectUrl = (location) => {
    const returnPath = getReturnPath(location);

    return `${process.env.REACT_APP_LOGIN_REDIRECT_URL || ''}${encodeURIComponent(returnPath)}`;
};

export const redirectToLogin = (location) => {
    window.location.href = getLoginRedirectUrl(location);
};

export const redirectToZlogin = () => {
    window.location.href = process.env.REACT_APP_ZLOGIN_URL;
};

const expireCookie = (name, domain) => {
    if (!name) {
        return;
    }

    const domainPart = domain ? `; domain=${domain}` : '';
    document.cookie = `${name}=; Max-Age=0; path=/${domainPart}; Secure; SameSite=Lax`;
};

export const clearLocalAuthState = () => {
    const cookieName = process.env.REACT_APP_COOKIE_NAME;
    const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;
    const storageKeys = [...new Set([cookieName, ...TOKEN_STORAGE_KEYS].filter(Boolean))];

    storageKeys.forEach((key) => {
        window.localStorage.removeItem(key);
        window.sessionStorage.removeItem(key);
    });

    expireCookie(cookieName);
    expireCookie(cookieName, cookieDomain);
};

export const logout = () => {
    clearLocalAuthState();
    // Redirect to the env-specific login-app logout endpoint; the login app clears the shared OneQrew/infleet session.
    window.location.href = process.env.REACT_APP_LOGOUT_URL || new URL('logout', process.env.REACT_APP_ZLOGIN_URL).toString();
};
